module.exports = __webpack_public_path__ + "media/images/landing/icon-product-presentation-fa5b7f76dd52233f09e87ac12a4be15d.svg";